import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/context/CartContext";

export const Nav = () => {
  const { count, setOpen } = useCart();
  const { pathname } = useLocation();
  const dark = pathname === "/" || pathname.startsWith("/payment");

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 mix-blend-difference text-white`}
    >
      <div className="flex items-center justify-between px-6 md:px-12 py-6">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3 font-serif text-2xl md:text-3xl tracking-[0.35em] font-medium"
        >
          <img
            src="/brand/logo-peony-white.png"
            alt="PAEON peony mark"
            data-testid="nav-logo-icon"
            className="h-6 md:h-8 w-auto"
          />
          PAEON
        </Link>
        <nav className="flex items-center gap-6 md:gap-10 text-[11px] tracking-[0.25em] uppercase font-medium">
          <Link
            to="/shop"
            data-testid="nav-shop-link"
            className="hover:opacity-50 transition-opacity duration-300"
          >
            Shop
          </Link>
          <Link
            to="/#manifesto"
            data-testid="nav-manifesto-link"
            className="hidden md:block hover:opacity-50 transition-opacity duration-300"
            onClick={(e) => {
              if (pathname === "/") {
                e.preventDefault();
                document.getElementById("manifesto")?.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Manifesto
          </Link>
          <button
            onClick={() => setOpen(true)}
            data-testid="nav-cart-button"
            className="uppercase tracking-[0.25em] hover:opacity-50 transition-opacity duration-300"
          >
            Cart ({count})
          </button>
        </nav>
      </div>
    </header>
  );
};
